import ProgressBar from "progressbar.js";

export default {

  init() {
    // JavaScript to be fired on the single enrolment page

    const bar = new ProgressBar.Line(container, {
      strokeWidth: 2,
      easing: 'easeInOut',
      duration: 2000,
      color: '#00A651',
      trailColor: '#eee',
      trailWidth: 1,
      svgStyle: {width: '100%', height: '100%'},
      from: {color: '#BAD532'},
      to: {color: '#00A651'},
      step: (state, bar) => {
        bar.path.setAttribute('stroke', state.color);
      }
    });

    bar.animate(1.0);

    },
  finalize() {
    // JavaScript to be fired on the my-account page


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/online-course.js